import CONFIG from 'Config';
import { getUrlParamsByObject } from 'Utils/url';
import { INotificationResponseData } from './NotificationResponseData.interface';
import { request } from './request';

export const getNotifications = (channel?: string, limit?: number, offset?: number): Promise<INotificationResponseData> => {
  const searchParams = getUrlParamsByObject({ channel, limit, offset });
  return request<INotificationResponseData>(`${CONFIG.urls.notification}/messages${searchParams}`);
};
